import { useCallback, useEffect, useState } from 'react';

import { SelfieEmergencyFundReviewModal } from '../components/snapshots/SelfieEmergencyFundReviewModal';
import { SelfieMonthlyCheckModal } from '../components/snapshots/SelfieMonthlyCheckModal';
import { useEmergencyFundReviewQuery } from '../features/snapshots/queries';

export function usePostSelfieModals(snapshot, { enabled = true } = {}) {
  const snapshotId = snapshot?.id;
  const [efReviewOpen, setEfReviewOpen] = useState(false);
  const [checkOpen, setCheckOpen] = useState(false);
  const [activated, setActivated] = useState(false);

  const { data: efReview } = useEmergencyFundReviewQuery(snapshotId, {
    enabled: Boolean(snapshotId) && enabled && activated,
  });

  useEffect(() => {
    if (efReview && !efReview.show_review) {
      setEfReviewOpen(false);
    }
  }, [efReview]);

  const activateModals = useCallback(() => {
    setActivated(true);
    setEfReviewOpen(true);
    setCheckOpen(true);
  }, []);

  const modals =
    enabled && snapshot && activated ? (
      <>
        <SelfieEmergencyFundReviewModal
          snapshotId={snapshot.id}
          isOpen={efReviewOpen}
          onClose={() => setEfReviewOpen(false)}
        />
        <SelfieMonthlyCheckModal
          snapshotId={snapshot.id}
          year={snapshot.reference_year}
          month={snapshot.reference_month}
          isOpen={checkOpen && !efReviewOpen}
          onClose={() => setCheckOpen(false)}
        />
      </>
    ) : null;

  return { activateModals, modals };
}
